/**
 * Stats Counter Animation
 * Animates numbers from 0 to their target value when they come into view
 */

class StatsCounter {
  constructor() {
    this.sections = document.querySelectorAll('.stats-section');
    this.animated = new Set();
    
    if (this.sections.length > 0) {
      this.init();
    }
  }

  init() {
    // Create intersection observer
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      {
        threshold: 0.2,
        rootMargin: '0px'
      }
    );

    // Observe all stats sections
    this.sections.forEach(section => {
      this.observer.observe(section);
    });
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !this.animated.has(entry.target)) {
        this.animateSection(entry.target);
        this.animated.add(entry.target);
      }
    });
  }

  animateSection(section) {
    const duration = parseInt(section.dataset.animationDuration) || 2000;
    const numbers = section.querySelectorAll('.stats-block__number');

    numbers.forEach(numberElement => {
      this.animateNumber(numberElement, duration);
    });
  }

  animateNumber(element, duration) {
    const targetValue = parseFloat(element.dataset.target);
    const prefix = element.dataset.prefix || '';
    const suffix = element.dataset.suffix || '';
    const counter = element.querySelector('.stats-counter');

    if (!counter || isNaN(targetValue)) return;

    // Check if the number has decimals
    const hasDecimals = targetValue % 1 !== 0;
    const decimals = hasDecimals ? (targetValue.toString().split('.')[1] || '').length : 0;

    const startTime = performance.now();
    const startValue = 0;

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function (easeOutExpo)
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      
      const currentValue = startValue + (targetValue - startValue) * easeProgress;
      
      // Format the number
      const formattedValue = hasDecimals 
        ? currentValue.toFixed(decimals)
        : Math.floor(currentValue);

      counter.textContent = prefix + formattedValue + suffix;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Ensure final value is exact
        counter.textContent = prefix + targetValue + suffix;
      }
    };

    requestAnimationFrame(animate);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StatsCounter();
  });
} else {
  new StatsCounter();
}

// Reinitialize on Shopify section events (for theme editor)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new StatsCounter();
  });
}






